import React from "react";
import ZoneListForm from './list/ZoneListForm';
import CreateZoneForm from './create/CreateZoneForm';

const ZoneView = ({ displayList }) => {
  return displayList ? (
    <ZoneListForm />
  ) : (
    <CreateZoneForm />
  );
};

export default ZoneView;
